import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { postRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/ProjectDetailsPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

export interface standbyTransferParamsType {
  jobUuid: string;
  userUuids: Array<string>;
  shiftUuids: Array<string>;
}

const createStandbyTransfer = async ({
  userUuids,
  shiftUuids,
  jobUuid,
}: standbyTransferParamsType) => {
  const params = {
    user_uuids: userUuids,
    shift_uuids: shiftUuids,
  };

  const { data } = await postRequest<RequestSimplifiedData>(
    API.POST.standbyTransfer(jobUuid),
    params,
  );

  return data;
};

export const useCreateStandbyTransfer = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: createStandbyTransfer,
    onSuccess: (_, { userUuids }) => {
      handleSuccess(
        userUuids.length > 1
          ? formatMessage(messages.usersTransferred)
          : formatMessage(messages.userTransferred),
        1000,
      );
      client.invalidateQueries({ queryKey: [QUERY_KEYS.TARGET_SHIFT_OPTIONS] });
      client.invalidateQueries({ queryKey: [QUERY_KEYS.JOB_APPLICATIONS] });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS_COUNT],
      });
    },
    onError: handleError,
  });
};
